/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

/**
 * Canonical priority of every overlay badge (MEY3-2279/MEY3-2280). Mirrors
 * Mey\Catalog\ViewModel\Product\OverlayBadgeSelector on the PHP side so the pages
 * and the LiveSearch result grid pick and order overlay badges identically.
 *
 * selectionRank decides WHICH badges win when more than 2 are active at once, positionRank
 * decides the display order of the winners - these intentionally differ.
 */
const BADGE_RANKS = {
    sale: { selectionRank: 1, positionRank: 1 },
    forwinter: { selectionRank: 2, positionRank: 3 },
    allseasons: { selectionRank: 2, positionRank: 3 },
    innovative: { selectionRank: 4, positionRank: 4 },
    new: { selectionRank: 3, positionRank: 2 },
    sustainable: { selectionRank: 5, positionRank: 5 }
}

const MAX_BADGES = 2

/**
 * Selects at most two badges out of the given active badge keys and orders them for display.
 *
 * @param {string[]} activeBadgeKeys
 * @returns {string[]}
 */
export const selectOverlayBadges = (activeBadgeKeys) => {
    const candidates = Object.keys(BADGE_RANKS)
        .filter((key) => activeBadgeKeys.includes(key))
        .map((key) => ({ key, ...BADGE_RANKS[key] }))

    return candidates
        .sort((a, b) => a.selectionRank - b.selectionRank)
        .slice(0, MAX_BADGES)
        .sort((a, b) => a.positionRank - b.positionRank)
        .map((badge) => badge.key)
}
